import {LocalStorage} from '@wix/panda-js-utils'

// Still used in ADI settings
const CURRENT_ROUTE_LOCAL_STORAGE_KEY = 'currentPageRoute'

export const setCurrentRoute = (route: string) => LocalStorage.setItem(CURRENT_ROUTE_LOCAL_STORAGE_KEY, route)
